import { createResourceHook } from '@clover-util/use-resource';
import { useCeRequest } from './useCeRequest';

export const useCeResource = createResourceHook(useCeRequest);
